import api from '@pray/shared/utils/api';

import { abnLocaleTranslationsUrl, abnVariationQuery } from './paths';
import type { AbnVariationRef } from './types';

export async function removeAbnVariationTranslations(ref: AbnVariationRef, locale: string) {
  await api.executeDeleteRequest(abnLocaleTranslationsUrl(ref, locale), undefined, {
    params: abnVariationQuery(ref),
  });

  return { success: true };
}
